import { render } from "./tournament-ranker.vue?vue&type=template&id=9968a07c"
import script from "./tournament-ranker.vue?vue&type=script&lang=js"
export * from "./tournament-ranker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__